import { testimonials } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function Testimonials() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-10">
        <div className="reveal">
          <SectionHeading
            eyebrow="Client Voices"
            title="客户怎么说"
            subtitle="客户的信任与认可，是我们持续拓展品类、提升服务的最大动力。"
          />
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item, index) => (
            <figure
              key={item.name}
              className="reveal flex flex-col p-6 md:p-7 rounded-lg bg-background-50 border border-background-200"
              style={{ transitionDelay: `${index * 60}ms` }}
            >
              <i className="ri-double-quotes-l text-3xl text-accent-400"></i>
              <blockquote className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed flex-1">
                {item.quote}
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-background-200">
                <div className="font-heading font-semibold text-foreground-950 text-sm">{item.name}</div>
                <div className="mt-1 text-xs text-foreground-500">{item.role}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}